import Select from 'react-select';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect } from 'react';
import moment from 'moment';

import { ClientWithObjectsMinData } from 'api/objectHeader/types';
import useGetSmartMultiTraps from 'hooks/Traps/useGetSmartMultiTraps';
import useGetSBsTraps from 'hooks/Traps/SRBMTraps/useGetSRBMTraps';
import { useAppSelector } from 'slices';
import { TrapTableType } from 'components/TrapsTables/trapTables';
import { useGetHubs } from 'hooks/Traps/Hubs/useGetHubs';
import { ReportTableType } from 'components/ReportsTables/ReportTableType';
import useGetMCTMonitoring from 'hooks/Reports/MCTMonitoring/MCTMonitoring';
import useGetSBSMonitoring from 'hooks/Reports/SBSMonitoring/SBSMonitoring';
import useGetObjectEncs from 'hooks/ObjectEnc/useGetObjectEnc';
import useGetObjectVuls from 'hooks/ObjectVuls/useGetObjectVuls';
import { AnaliticsTableType } from 'components/AnalyticsPage/AnalyticsPageTypes';
// import { useAllTrapsActivityBarChartState } from 'hooks/Analitics/MCTCharts/1_allTrapsActivityBarChart/useAllTrapsActivityBarChartState';
// import { useChartData } from 'hooks/Analitics/MCTCharts/2_trapsActivityLineChart/useChartStates';
// import { useGetMiceToTrapAmountChartState } from 'hooks/Analitics/MCTCharts/4_miceToTrapAmountLineChart/useGetMiceToTrapAmountChartState';
// import { useGetMiceActivityTableState } from 'hooks/Analitics/MCTCharts/3_miceActivityDonutChart/useGetMiceActivityTableState';
// import { useGetTotalEatenBaitLineChartState } from 'hooks/Analitics/SBSCharts/1_TotalEatenBaitLineChart/useGetTotalEatenBaitChartState';
// import { useGetVulsLineChartState } from 'hooks/Analitics/VulsCharts/1_PeriodVulsLineChart/useGetVulsLineChartState';
import { VisitsAndScheduledTasksTableType } from 'components/VisitsAndScheduledTasks/visitsAndScheduledTasks';
import useGetVisitReportsList from 'hooks/VisitReport/useGetVisitReportsList';
import useGetPeriodReportList from 'hooks/PeriodReports/useGetPeriodReports';
// import { TrapType } from 'components/AnalyticsPage/TrapType';

interface ObjectOption {
  value: string;
  label: string;
}

interface Group {
  label: string;
  options: ObjectOption[];
}

interface Props {
  dropDownData: ClientWithObjectsMinData;
  location: any;
}

const SelectObjectDropdown: React.FC<Props> = ({ dropDownData, location }) => {
  const { slug } = useParams();
  const initialStartDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
  const initialEndDate = moment().format('YYYY-MM-DD');
  const currentTabTraps = useAppSelector(state => state.Traps.currentTrapTable);
  const currentTabMonitorings = useAppSelector(state => state.Reports.currentReportTable);
  const currentTabAnalitics = useAppSelector(state => state.Analitics.currentAnalyticsPage);
  const currentVisitsAndScheduledTasksTable = useAppSelector(
    state => state.VisitsAndScheduledTasksTable.currentVisitsAndScheduledTasksTable,
  );
  const { refetch: refetchMCT } = useGetSmartMultiTraps(slug || '', false);
  const { refetch: refetchSBS } = useGetSBsTraps(slug || '', 1, '', '', false);
  const { refetch: refetchHubs } = useGetHubs(slug || '', 1, '', '', false);
  const { refetch: refetchMonitoringMCT } = useGetMCTMonitoring(
    slug || '',
    initialStartDate,
    initialEndDate,
    'default',
    false,
  );
  const { refetch: refetchMonitoringSBS } = useGetSBSMonitoring(
    slug || '',
    initialStartDate,
    initialEndDate,
    'default',
    false,
  );
  const { refetch: refetchEncounters } = useGetObjectEncs(slug || '', false);
  const { refetch: refetchVulnerabilities } = useGetObjectVuls(slug || '', false);
  // useAllTrapsActivityBarChartState({ slug: slug || '', trapType: TrapType.MCT });
  // const { refetch: refetchMCTAnalitic2 } = useChartData({ slug: slug || '', trapType: TrapType.ALL });
  // const { refetch: refetchMCTAnalitic3 } = useGetMiceToTrapAmountChartState({
  //   slug: slug || '',
  //   trapType: TrapType.ALL,
  // });
  // const { refetch: refetchMCTAnalitic4 } = useGetMiceActivityTableState({ slug: slug || '' });
  // const { refetch: refetchSBSAnalitic1 } = useGetTotalEatenBaitLineChartState({ slug: slug || '' });
  // useGetVulsLineChartState({ slug: slug || '' });

  const { refetch: refetchVisitReports } = useGetVisitReportsList({ slug: slug || '', enabled: false });
  const { refetch: refetchPeriodReports } = useGetPeriodReportList({ slug: slug || '', enabled: false });

  const navigate = useNavigate();
  const currentPath = location.pathname;
  const clientOptions: Group[] = Object.entries(dropDownData).reduce<Group[]>((acc, [clientName, objects]) => {
    acc.push({
      label: clientName,
      options: objects.map(obj => ({
        value: obj.obj_slug,
        label: obj.obj_name,
      })),
    });
    return acc;
  }, []);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    const pageName = currentPath.split('/').slice(-2)[0];

    if (pageName === 'traps') {
      if (currentTabTraps === TrapTableType.MultiCatchMouseTraps) {
        refetchMCT();
      } else if (currentTabTraps === TrapTableType.SmartRodenBaitModule) {
        refetchSBS();
      } else if (currentTabTraps === TrapTableType.Hubs) {
        refetchHubs();
      }
    } else if (pageName === 'monitorings') {
      if (currentTabMonitorings === ReportTableType.MCTMonitoring) {
        refetchMonitoringMCT();
      } else if (currentTabMonitorings === ReportTableType.SRBMMonitoring) {
        refetchMonitoringSBS();
      }
    } else if (pageName === 'encounters') {
      refetchEncounters();
    } else if (pageName === 'vulnerabilities') {
      refetchVulnerabilities();
    } else if (pageName === 'analitics') {
      if (currentTabAnalitics === AnaliticsTableType.MouseTrapsAnalytics) {
        // refetchMCTAnalitic1(); // This line was removed as per the edit hint
        // refetchMCTAnalitic2();
        // refetchMCTAnalitic3();
        // refetchMCTAnalitic4();
      } else if (currentTabAnalitics === AnaliticsTableType.SmartRodentBaitModule) {
        // refetchSBSAnalitic1();
      } else if (currentTabAnalitics === AnaliticsTableType.Vulnerabilities) {
        // refetchVulsAnalitic1(); // This line was removed as per the edit hint
      }
    } else if (pageName === 'visits-and-scheduled-tasks') {
      if (currentVisitsAndScheduledTasksTable === VisitsAndScheduledTasksTableType.VisitReports) {
        refetchVisitReports();
      } else if (currentVisitsAndScheduledTasksTable === VisitsAndScheduledTasksTableType.PeriodReports) {
        refetchPeriodReports();
      }
    }
  }, [
    slug,
    currentPath,
    currentTabTraps,
    currentTabMonitorings,
    currentTabAnalitics,
    currentVisitsAndScheduledTasksTable,
  ]);

  const handleSelectChange = (selectedOption: any) => {
    const selectedSlug = selectedOption.value;
    const currentPath = location.pathname;
    const pathParts = currentPath.split('/');

    // If we're on the interactive map page, navigate without plan slug
    if (pathParts.includes('interactive-map')) {
      const newPath = `/object/interactive-map/${selectedSlug}`;
      navigate(newPath);
    } else {
      const newPath = currentPath.split('/').slice(0, -1).concat(selectedSlug).join('/');
      navigate(newPath);
    }
  };

  return (
    <div className="d-flex flex-column gap-1" title="Select Client Site">
      <Select
        styles={{
          control: provided => ({
            ...provided,
            backgroundColor: 'white',
            color: 'black',
            border: '2px solid #6a37d4',
            padding: '0px',
            fontSize: '12px',
            cursor: 'pointer',
            boxShadow: 'none',
            fontWeight: 'bold',
            width: '200px',
            minWidth: '180px',
          }),
          singleValue: provided => ({
            ...provided,
            color: 'black',
          }),
          placeholder: provided => ({
            ...provided,
            color: 'black',
          }),
          menu: provided => ({
            ...provided,
            backgroundColor: 'white',
            zIndex: 9999,
            outline: 'none',
            border: '1px solid #6a37d4',
            boxShadow: 'none',
          }),
          option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isSelected ? '#5f00cc' : state.isFocused ? '#d4b0f5' : 'white',
            color: state.isSelected ? 'white' : state.isFocused ? 'white' : 'black',
            cursor: 'pointer',
          }),
          dropdownIndicator: provided => ({
            ...provided,
            color: 'black',
          }),
        }}
        options={clientOptions}
        defaultValue={clientOptions.flatMap(group => group.options).find(option => option.value === slug)}
        value={clientOptions.flatMap(group => group.options).find(option => option.value === slug)}
        placeholder="Select Site"
        isSearchable
        onChange={handleSelectChange}
        getOptionLabel={e => e.label}
      />
    </div>
  );
};

export default SelectObjectDropdown;
